export const helpLink = 'https://support.esgisoftware.com';
export const withScoresExampleImageUrl = 'https://s3.amazonaws.com/esgiwebfiles/images/with-score-example.png';
export const withoutScoresExampleImageUrl = 'https://s3.amazonaws.com/esgiwebfiles/images/without-score-example.png';
